import * as angular from "angular";
import {IController, IScope} from "angular";

export class DepotTableRowComponent implements IController {

  depotId: any;
  onSelect: Function;
  onRemove: Function;

  /* @ngInject */
  constructor(private $depots, private $scope: IScope) {

  }

  $onInit() {
    if (this.depotId) {
      this.$depots(this.depotId).$bindCtrlToId(this.$scope, this, 'depot', 'depotId');
    }
  }

  $onChanges(changes) {
    if (changes.depotId && !changes.depotId.isFirstChange()) {
      this.$onInit();
    }
  };
}

angular
  .module('bringoz.admin.depots')
  .component('depotTableRow', {
    bindings: {
      depotId: '<',
      onSelect: '&',
      onRemove: '&'
    },
    template: require('./depot-table-row.html').default,
    controller: DepotTableRowComponent
  });
